import { createFileRoute } from "@tanstack/react-router";
import { SEO } from "@/features/marketing/seo";
import { GuestListTool } from "@/features/marketing/tools/guest-list-tool";

export const Route = createFileRoute("/_marketing/wedding-guest-list-template")({
  head: SEO.guestList,
  component: GuestListTool,
});
